<template>

  <div class="box-login">
    <div class="container">
      <div class="legend">
        <p class="text--white">
          Ingresa a Ekscelenko
        </p>
        <ul class="legend-list text--white">
          <li>Contacta a nuestros ejectivos</li>
        </ul>
      </div>
      <div class="login-form mb-3">
        <fieldset v-if="!status.email">
            <p class="-centered-info">Inicia sesión</p>
            <label
              class="material-label"
              :class="errors ? 'material-label--error' : ''"
              for="Correo">
                Correo
            </label>
            <input
              class="material-input"
              :class="errors
              || status.passwordError !== null
              ? 'material-input--error'
              : ''"
              name="Correo" type="email"
              v-focus v-model="$v.user.email.$model"
              v-on:keyup.13="sendUserEmail()"
            >
            <p
              class="password-recovery mb-4"
              @click.prevent="$modal.show('user-reset-password')">
                Olvidé mi contraseña
            </p>
            <p class="error" v-if="errors">
              <span v-if="!$v.user.email.required">El correo es obligatorio</span>
              <span v-if="!$v.user.email.email">No es un correo válido</span>
            </p>
            <button
              class="btn btn--green button-fullwidth"
              :disabled="checkEmail(user.email)"
              @click.prevent="sendUserEmail()">
                Continuar
            </button>
            <p
              class="account-confirmation-text"
              @click.prevent="$modal.show('resend-verification-email')">
                Reenviar confirmación de cuenta
            </p>
          </fieldset>
          <div v-else>
            <p
              class="-centered-info"
              v-if="userSecurity.hash">
                <b>{{ userSecurity.hash }}</b>
            </p>
            <fieldset>
              <label
                class="material-label"
                :class="errors
                || status.passwordError !== null
                ? 'material-label--error'
                : ''"
                for="Contraseña">
                  Contraseña
              </label>
              <div class="password-field">
                <input
                  class="material-input mb-4"
                  :class="errors
                  || status.passwordError !== null
                  ? 'material-input--error'
                  : ''"
                  name="Contraseña"
                  :type="password"
                  v-focus
                  v-model="$v.userSecurity.password.$model"
                  v-on:keyup.13="sendUserPassword()"
                >
                <span @click="changeType()" class="togglepassword reveal-password">
                  <img src="https://icongr.am/fontawesome/eye-slash.svg?color=9b9b9b&size=18" v-if="password === 'password'">
                  <img src="https://icongr.am/fontawesome/eye.svg?color=00C569&size=18" v-if="password === 'text'">
                </span>
              </div>
            </fieldset>
            <p
              class="password-recovery mt-4 mb-1"
              @click.prevent="$modal.show('user-reset-password')">
                Olvidé mi contraseña
            </p>
            <p class="error" v-if="errors">
              <span v-if="!$v.userSecurity.password.required">La contraseña es obligatoria</span>
              <span v-if="!$v.userSecurity.password.minLength">La contraseña es de 6 caracteres mínimo</span>
            </p>
            <p class="errormessage" v-if="status.passwordError !== null">{{ status.passwordError.toString() }}</p>
            <button class="btn button-fullwidth mt-6" :disabled="!userSecurity.password" @click.prevent="sendUserPassword()">Ingresar</button>
            <button class="btn btn--outline btn--outline--green button-fullwidth mt-1_5" @click.prevent="changeEmail">Cambiar correo</button>
          </div>
      </div>
    </div>
    <modal name="user-reset-password" id="reset-password" width="80%" :maxWidth="480" :adaptive="true" height="auto">
      <div class="box-reset">
        <h3 class="title">¿Olvidaste tu contraseña?</h3>
        <a href="#" class="close" @click.prevent="$modal.hide('user-reset-password')">
          <img alt="Ingresa" src="https://icongr.am/material/close.svg?size=20&color=currentColor">
        </a>
        <div v-if="!status.passwordReset">
          <p>Para cambiar tu contraseña, por favor ingresa el correo registrado en <b class="-green">Cumplo</b> para Ekscelenko.</p>
          <p class="no-margin">
            <label class="material-label" for="Correo">Correo</label>
            <input class="material-input" type="text" name="Correo" v-model="user.email">
          </p>
        </div>
        <div v-else>
          <p>Se ha enviado un correo a la cuenta
            <b class="-green">{{ user.email }}</b> con un enlace para cambiar tu contraseña.
              Por favor revisa tu buzón de entrada (y spam) y haz clic en el enlace,
              o puedes copiarlo y pegarlo en el navegador. Luego podrás cambiar tu contraseña.
          </p>
        </div>
      </div>
      <div class="modal-buttons" v-if="!status.passwordReset">
        <button class="btn btn--green" :disabled="checkEmail(user.email)" @click.prevent="sendResetEmail()">Enviar</button>
      </div>
      <div class="modal-buttons" v-else>
        <button class="button"  @click.prevent="closeUserResetPasswordModal()">Cerrar</button>
      </div>
    </modal>
    <modal name="resend-verification-email" id="reset-password" width="80%" :maxWidth="480" :adaptive="true" height="auto">
      <div class="box-reset">
        <h3 class="title">Confirmación de cuenta</h3>
        <a href="#" class="close" @click.prevent="$modal.hide('resend-verification-email')">
          <img alt="Ingresa" src="https://icongr.am/material/close.svg?size=20&color=currentColor">
        </a>
        <div v-if="!status.passwordResend">
          <p>Si no has recibido el correo de confirmación de tu cuenta, por favor ingresa el correo registrado en <b class="-green">Cumplo</b> para Ekscelenko.</p>
          <p class="no-margin">
            <label class="material-label" for="Correo">Correo</label>
            <input class="material-input" type="text" name="Correo" v-model="user.email">
          </p>
        </div>
        <div v-else>
          <p>Se ha enviado un correo a la cuenta
            <b class="-green">{{ user.email }}</b> con un enlace para confirmar tu cuenta.
              Por favor revisa tu buzón de entrada (y spam) y haz clic en el enlace,
              o puedes copiarlo y pegarlo en el navegador. Luego podrás entrar a tu cuenta e invertir en Cumplo.
          </p>
        </div>
      </div>
      <div class="modal-buttons" v-if="!status.passwordResend">
        <button class="btn btn--green" :disabled="checkEmail(user.email)" @click.prevent="sendConfirmEmail()">Enviar</button>
      </div>
      <div class="modal-buttons" v-else>
        <button class="btn btn--green"  @click.prevent="$modal.hide('resend-verification-email')">Cerrar</button>
      </div>
    </modal>
  </div>

</template>

<script>

import {format, differenceInMinutes} from 'date-fns'
import { required, email, minLength } from 'vuelidate/lib/validators'

import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)

export default {
  name: 'LogIn',
  metaInfo () {
    return {
      title: 'Ingresa a tu cuenta | Cumplo'
    }
  },
  validations: {
    user: {
      email: { required, email }
    },
    userSecurity: {
      password: {
        required,
        minLength: minLength(6)
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  mixins: [mixins, httpRequestMixin],
  data () {
    return {
      sofomSignup: `/registro`,
      errors: false,
      empty: false,
      format,
      differenceInMinutes,
      user: {
        email: this.$route.query.email || ''
      },
      userSecurity: {
        password: '',
        hash: null
      },
      status: {
        email: false,
        passwordError: null,
        passwordReset: false,
        passwordResend: false
      },
      password: 'password',
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  methods: {
    changeEmail: function () {
      this.status.email = false
      this.user.email = ''
      this.userSecurity.password = ''
      this.status.passwordError = null
      this.errors = false
    },
    changeType: function () {
      this.password === 'password'
        ? this.password = 'text'
        : this.password = 'password'
    },
    closeUserResetPasswordModal: function () {
      this.$modal.hide('user-reset-password')
      this.$router.replace({ name: 'LogIn' })
    },
    sendResetEmail: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/auth/password-reset/',
        params: {
          email: this.user.email
        }
      }

      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.status.passwordReset = true
      }
    },
    sendConfirmEmail: async function () {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/auth/request-confirm/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          'email': this.user.email
        }
      }

      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.status.passwordResend = true
      }
    },
    sendUserEmail: async function () {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/auth/validate/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          'email': this.user.email
        }
      }

      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.status.email = true
        this.userSecurity.hash = response.data.user
      }
    },
    sendUserPassword: function () {
      this.$store.dispatch('login', {
        email: this.user.email,
        password: this.userSecurity.password
      })
        .then(response => {
          if (response.status === 200) {
            if (sessionStorage.getItem('sofom_back_to_fr')) {
              const frId = sessionStorage.getItem('sofom_fr_id')
              this.$router.replace({
                name: 'RequestDetail',
                params: { market: 'mx', id: `${frId}` } })
            } else {
              switch (this.prevRoute.name) {
                case null:
                case 'SignUp':
                case 'VerifyEmail':
                case 'ResetPassword':
                  this.$router.replace({ name: 'Home' })
                  break
                default:
                  this.$router.replace({ name: this.prevRoute.name })
                  break
              }
            }
          }
        })
        .catch((error) => {
          if (error.status === 401 || error.status === 403) {
            this.status.passwordError = error.data.error
          } else {
            this.sendErrorToLogger(this.$options.name, error.message)
          }
        })
    }
  }
}

</script>

<style lang="scss">

#reset-password {

  .box-reset {
    padding: 2rem;
    border-radius: 12px;
  }

  .title {
    color: $midnight-blue;
    border-bottom: 1px solid #ccc;
    font-weight: normal;
    text-align: left;
    font-size: 1.6em;
  }

  .close {
    $offset: 15px;

    position: absolute;
    top: $offset;
    right: $offset;
  }

  .modal-buttons {
    margin-bottom: 2rem;
    text-align: center;
  }
}

</style>

<style lang="scss" scoped>

.box-login {
  padding: 5rem 0;
  min-height: 450px;
  background: rgb(60,186,104);
  background: linear-gradient(180deg, rgba(60,186,104,1) 5%, rgba(11,171,100,1) 30%, rgba(53,87,76,1) 63%);
}

.errormessage {
    color: $red;
    font-size: .9em;
    font-weight: bold;
  }

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.legend {
  margin: 0;
  margin-bottom: 2em;
  font-weight: bold;
  font-size: 1.3em;
}

.legend-list {
  font-weight: normal;
}

ul li::before {
  content: url('https://icongr.am/material/check-circle-outline.svg?size=25&color=ffffff');
  margin-right: .5em;
}

.login-form {
  width: 100%;
  max-width: 510px;
  background-color: $white;
  border-radius: 12px;
  padding: 2em 1em;
  margin: 0 auto;
}

.registration-text {
  font-size: .8em;
  text-align: center;
  margin: 0;
  margin-top: 1.5em;
  font-weight: bold;
}

.account-confirmation-text {
  color: #0CACFF;
  text-align: center;
  font-size: .8em;
  margin: 0;
  padding: 0;
  margin-top: 2em;
  margin-bottom: -2em;
  cursor: pointer;

  &:hover {
    font-weight: bold;
  }
}

.password-field {
  display: flex;
  height: 0;
}

.reveal-password {
  margin-top: .5em;
  margin-right: .2em;
  padding: 0;
  height: 0;
}

.password-recovery {
  font-size: .8em;
  cursor: pointer;
  color: #0CACFF;

  &:hover {
    font-weight: bold;
  }
}

@media (min-width: 760px) {

  .login-form {
    padding: 2em 2em;
  }
}

@media (min-width: 1023px) {
  .container {
    width: 100%;
    flex-direction: row;
  }

  .legend {
    margin-right: 2em;
  }

  .login-form {
    margin-left: 5em;
  }

  .account-confirmation-text {
    margin-top: 4em;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/LogIn.vue